import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { SessionActivityItem } from './session-activity-item';
export { SessionActivityItem };
import { sessionActivityItemSchema } from '@schemas/business-objects/session-activity-item';
import { ActivityItemFormGroup } from './activity-item-form-group';
import { ResourceFormGroup } from './resource-form-group';
import { SessionFormGroup } from './session-form-group';

export class SessionActivityItemFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    textValue: SchemaFormControl;
    numberValue: SchemaFormControl;
    sessionId: SchemaFormControl;
    session: SessionFormGroup;
    activityItemId: SchemaFormControl;
    activityItem: ActivityItemFormGroup;
    resourceId: SchemaFormControl;
    resource: ResourceFormGroup;
  };

  declare value: Partial<SessionActivityItem>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(sessionActivityItemSchema, SessionActivityItem, data, options);
  }

  get object(): SessionActivityItem {
    return new SessionActivityItem(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'session':
        return new SessionFormGroup();
      case 'activityItem':
        return new ActivityItemFormGroup();
      case 'resource':
        return new ResourceFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<SessionActivityItem[]> {
    return SessionActivityItem.find(filter);
  }

  static async findOne(filter?: any): Promise<SessionActivityItem | null> {
    return SessionActivityItem.findOne(filter);
  }

  static async findById(
    id: number,
    filter?: any,
  ): Promise<SessionActivityItem> {
    return SessionActivityItem.findById(id, filter);
  }

  static async create(
    data: Partial<SessionActivityItem>,
  ): Promise<SessionActivityItem> {
    return SessionActivityItem.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<SessionActivityItem>,
  ): Promise<SessionActivityItem> {
    return SessionActivityItem.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return SessionActivityItem.deleteById(id);
  }
}

export class SessionActivityItemFormArray extends PersistedFormArray {
  readonly entityName = 'SessionActivityItem' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(sessionActivityItemSchema, SessionActivityItem, options);
  }

  protected override createItemGroup() {
    return new SessionActivityItemFormGroup();
  }

  get array(): SessionActivityItem[] {
    return this.controls.map(
      (group: SessionActivityItemFormGroup) => group.object,
    );
  }
}

export class SessionActivityItemPersistedArray extends PersistedArray<SessionActivityItem> {
  readonly entityName = 'SessionActivityItem' as const;

  constructor(options?: PersistedArrayOptions) {
    super(SessionActivityItem, options);
  }
}
